import { parseFloatSafe } from "@omni/utils/number.utils";
import queryString from "query-string";
import { PureComponent } from "react";

import * as CalculatorStepTracker from "@/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@/services/tracking/trackers/tools/calculators/config";
import { asyncState } from "@/utils/calculators";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

type StabilizedsandCalculatorState = {
    stabilizedsandLength: string;
    stabilizedsandWidth: string;
    stabilizedsandThickness: string;
    stabilizedsandArea: number;
    stabilizedsandVolume: number;
};

class StabilizedsandCalculator extends PureComponent<
    {},
    StabilizedsandCalculatorState
> {
    query = queryString.parse(location.search);

    constructor(props: {}) {
        super(props);
        this.state = {
            stabilizedsandLength:
                this.query.stabilizedsandLength?.toString() || "0",
            stabilizedsandWidth:
                this.query.stabilizedsandWidth?.toString() || "0",
            stabilizedsandThickness:
                this.query.stabilizedsandThickness?.toString() || "0",
            stabilizedsandArea: 0,
            stabilizedsandVolume: 0
        };
    }

    async componentDidMount() {
        await asyncState(this, {
            stabilizedsandArea: this.stabilizedsandArea(),
            stabilizedsandVolume: this.stabilizedsandVolume()
        });

        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.stabilizedSand);
    }

    stabilizedsandArea = () => {
        return (
            parseFloatSafe(this.state.stabilizedsandLength, 0) *
            parseFloatSafe(this.state.stabilizedsandWidth, 0)
        );
    };
    stabilizedsandVolume = () => {
        const length = this.state.stabilizedsandLength;

        const width = this.state.stabilizedsandWidth;

        const thickness =
            parseFloatSafe(this.state.stabilizedsandThickness, 0) * 0.01; // convert cm to m
        return parseFloatSafe(length, 0) * parseFloatSafe(width, 0) * thickness;
    };

    setCalculationValue = (field: string, value: string) => {
        this.setState(
            (state) => ({ ...state, [field]: value }),
            () => {
                this.setState({
                    stabilizedsandArea: this.stabilizedsandArea(),
                    stabilizedsandVolume: this.stabilizedsandVolume()
                });

                CalculatorStepTracker.trackSubmit(
                    CALCULATOR_KEYS.stabilizedSand
                );
            }
        );
    };

    render() {
        const calculationProps = {
            setCalculationValue: this.setCalculationValue,
            stabilizedsandLength: this.state.stabilizedsandLength,
            stabilizedsandWidth: this.state.stabilizedsandWidth,
            stabilizedsandThickness: this.state.stabilizedsandThickness
        };
        const resultProps = {
            stabilizedsandArea: this.state.stabilizedsandArea,
            stabilizedsandVolume: this.state.stabilizedsandVolume,
            mailParams: {
                stabilizedsandLength: this.state.stabilizedsandLength,
                stabilizedsandWidth: this.state.stabilizedsandWidth,
                stabilizedsandThickness: this.state.stabilizedsandThickness
            }
        };

        return (
            <div id="calculator">
                <Calculation {...calculationProps} />
                <Result {...resultProps} />
            </div>
        );
    }
}

export { StabilizedsandCalculator };
